import { Box, Divider, Grid, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import { InfoBox } from "../designUi";
import { MessageIconCover } from "../UIElements/svgIcons";
import PieChart from "../charts/pieChart";
import {
  FacilityHorizontalBarChart,
  
} from "./facilityCharts";
import { extractKeys, extractValues } from "../../utils/extract";
import EmploymentPieChart from "./facilityPieChart";
import { JobEmpStatus } from "./jobFacility";
import FacilityPieChart from "./facilityPieChart";
import { FacilityJobStatsProps } from "../../interface/facility";

const JobStats = ({ stats }: {stats: FacilityJobStatsProps}) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");

  

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: isSmall ? "column" : "row",
          flexWrap: "wrap",
          justifyContent: "center",
          backgroundColor: "#F0F4FF",
          p: 3,
          my: 3,
          mx: 3,
          gap: 3,
        }}
      >
        <Stack sx={{ width: isSmall ? "98%" : "48%" }}>
          <InfoBox
            title={"Total Applicants"}
            value={stats?.totalApplicants ?? 0}
            icon={<MessageIconCover />}
          />
        </Stack>
        <Stack sx={{ width: isSmall ? "98%" : "48%" }}>
          <InfoBox
            title={"Total Jobs"}
            value={stats?.totalJobs ?? 0}
            icon={<MessageIconCover />}
          />
        </Stack>
        <Stack sx={{ width: isSmall ? "98%" : "48%" }}>
          <InfoBox
            title={"Total Pending Reviews"}
            value={stats?.totalPendingReviews ?? 0}
            icon={<MessageIconCover />}
          />
        </Stack>
        <Stack sx={{ width: isSmall ? "98%" : "48%" }}>
          <InfoBox
            title={"Total Shortlisted"}
            value={stats?.totalShortlisted ?? 0}
            icon={<MessageIconCover />}
          />
        </Stack>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: isMedium ? "column" : "row",
          justifyContent: "space-between",
          paddingX: 3,
          paddingY: 3,
        }}
      >
        <Box
          sx={{
            width: isMedium ? "100%" : "60%",
          }}
        >
          <Box sx={{}}>
            <Stack sx={{ width: "100%" }}>
              {/* <FacilityHorizontalBarChart
                name={"Active Employees JobType"}
                data={extractValues(stats?.employmentTypeCount)}
                labels={extractKeys(stats?.jobTitleCount)}
              /> */}
            </Stack>
            <Stack
              direction={isSmall ? "column" : "row"}
              justifyContent={"center"}
              spacing={2}
            >
              <FacilityPieChart
                name="Active Employees Type"
                data={extractValues(stats?.employmentTypeCount)}
                labels={extractKeys(stats?.employmentTypeCount)}
              />
              <FacilityPieChart
                name="Active Employees WorkType"
                data={extractValues(stats?.jobTypeCount)}
                labels={extractKeys(stats?.jobTypeCount)}
              />
            </Stack>
          </Box>
        </Box>
        <Box sx={{ width: isMedium ? "100%" : "40%" }}>
          {/* <EmploymentBarChart
            id={getIds(stats.activeEmployeesDepartment)}
            labels={getCounts(stats?.activeEmployeesDepartment)}
          /> */}
        </Box>
      </Box>
    </>
  );
};

export default JobStats;
